import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcMapPinOl = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "ic_map_pin_ol",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.03116 6.03116C9.77583 3.28649 14.2258 3.28649 16.9705 6.03116C19.7152 8.77583 19.7152 13.2258 16.9705 15.9705L12.0008 20.9402L7.03116 15.9705C4.28649 13.2258 4.28649 8.77583 7.03116 6.03116ZM18.0312 4.9705C14.7007 1.64004 9.30096 1.64004 5.9705 4.9705C2.64004 8.30096 2.64004 13.7007 5.9705 17.0312L11.4705 22.5312C11.6112 22.6718 11.8019 22.7508 12.0008 22.7508C12.1997 22.7508 12.3905 22.6718 12.5312 22.5312L18.0312 17.0312C21.3616 13.7007 21.3616 8.30096 18.0312 4.9705ZM10.75 11C10.75 10.3096 11.3096 9.75 12 9.75C12.6904 9.75 13.25 10.3096 13.25 11C13.25 11.6904 12.6904 12.25 12 12.25C11.3096 12.25 10.75 11.6904 10.75 11ZM12 8.25C10.4812 8.25 9.25 9.48122 9.25 11C9.25 12.5188 10.4812 13.75 12 13.75C13.5188 13.75 14.75 12.5188 14.75 11C14.75 9.48122 13.5188 8.25 12 8.25Z",
			fill: "#6B7070"
		})
	})
});
export default SvgIcMapPinOl;
